// App.js
import React from 'react';
// import './App.css';
import AppRouter from './components/AppRouter.jsx';
// import NavbarProfile from './components/NavbarProfile.jsx';
//  import DoctorDetails from './components/Reports';
// import ScanQR from './components/ScanQR';
//  import WebcamCapture from './components/Patientadd';
// import Contacts from './components/PatientContacts';

function App() {
  return (
    <div className="App">
      <AppRouter />
      {/* <DoctorDetails />  */}
      {/* <WebcamCapture /> */}
      {/* <NavbarProfile /> */}
      {/* <ScanQR /> */}
       {/* <Contacts /> */}

    </div>
  );
}

export default App;
